import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import OrderConstants from '../constants/OrderConstants';
import OrderApiUtils from '../utils/OrderApiUtils';

let _orderData = {};
let _showPopup = false;
let _bankId = 'DYB';
let _pageStatus = 'page';
let serviceResponseParameters = {};

class OrderStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getOrderData() {
    return _orderData;
  }
  getPopupData() {
    return serviceResponseParameters;
  }
  getPopupFlag() {
    return _showPopup;
  }
  getBankId() {
    return _bankId;
  }
  getPageStatus() {
    return _pageStatus;
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case OrderConstants.ORDER_DATA:
        _orderData = actionData.data;
        _bankId = actionData.data.bankId;
        this.emitChange();
        break;
      case OrderConstants.ORDER_TYPE:
        _pageStatus = 'loader';
        OrderApiUtils.placeOrder(actionData.data);
        this.emitChange();
        break;
      case OrderConstants.ORDER_SUCCESS:
        _pageStatus = 'page';
        _showPopup = true;
        serviceResponseParameters = {
          status: actionData.data.status,
          type: actionData.data.type,
        };
        this.emitChange();
        break;
      case OrderConstants.ORDER_FAILURE:
        _pageStatus = 'page';
        _showPopup = true;
        serviceResponseParameters = {
          status: actionData.data.status,
          error: actionData.data.error,
          type: actionData.data.type,
        };
        this.emitChange();
        break;
      case OrderConstants.HANDLE_POPUP:
        _showPopup = actionData.data;
        break;
      default: {
        break;
      }
    }
  }
}

export default new OrderStore();
